import { defineComponent as v, ref as b, onMounted as y, watch as B, computed as m, resolveComponent as z, createElementBlock as C, openBlock as h, normalizeClass as g, createElementVNode as k, mergeProps as $, renderSlot as w, createBlock as A, createCommentVNode as _ } from "vue";
import { useRouter as P } from "vue-router";
import { a as S } from "./autoFocus-CVmVp5SB.js";
import { r as p } from "./ArrowPathIcon-B9ilFCuq.js";
import { _ as E } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const F = v({
  inheritAttrs: !1,
  components: { ArrowPathIcon: p },
  props: {
    color: {
      type: String,
      default: () => "primary"
    },
    fill: {
      type: String,
      default: () => "solid"
    },
    /** if href use router, skip dirty locks */
    href: [String, Object],
    /** hide and disabled */
    invisible: Boolean,
    disabled: Boolean,
    round: Boolean,
    onClick: { type: Function, default: () => {
    } },
    clicking: Boolean,
    size: String,
    iconOnly: Boolean,
    autofocus: Boolean,
    block: Boolean
    // // as
    // buttonType: string;
    // type: 'submit' | 'reset' | 'button';
    // // download a URL 
    // download: string | undefined;
    // target: string | undefined;
    // // Specifies the relationship of the target object to the link object. The value is a space-separated list of [link types](https://developer.mozilla.org/en-US/docs/Web/HTML/Link_types).
    // rel: string | undefined;
    // routerAnimation: AnimationBuilder | undefined;
    // routerDirection: RouterDirection;
    // expand: String as PropType<'full' | 'block'>
    // strong: boolean;
  },
  emits: ["click"],
  setup(t, { attrs: a }) {
    const r = P(), i = b(!1), c = b();
    function u() {
      var o;
      S((o = c.value) == null ? void 0 : o.$el, (e) => {
        e.classList.add("tx-button-focused"), e.addEventListener("blur", () => e.classList.remove("tx-button-focused"), { once: !0 });
      });
    }
    if (t.autofocus === !0)
      y(u);
    else if (t.autofocus === !1) {
      const o = B(
        () => t.autofocus,
        (e) => {
          e && (u(), o());
        }
      );
    }
    const s = m(() => {
      const { class: o, ...e } = a, l = {
        class: ["button-native"],
        ...e
      };
      l.disabled = t.disabled || t.invisible || i.value || t.clicking;
      const n = t.href, f = typeof n == "string" && (n.startsWith("mailto:") || n.startsWith("tel:") || n.startsWith("file/"));
      return f && (l.href = n), l.onClick = async (d) => {
        if (n && (d.preventDefault(), d.stopPropagation()), t.onClick)
          try {
            i.value = !0, await t.onClick();
          } finally {
            i.value = !1;
          }
        n && (f ? window.open(n, "_blank") : r.push(n));
      }, l;
    });
    return {
      button: c,
      ionArgs: s,
      containerClass: m(() => {
        const o = ["tx-button", `button-${t.fill}`, `tx-button-color-${t.color}`, a.class];
        return s.value.disabled && o.push("button-disabled"), t.invisible && o.push("invisible"), t.round && o.push("button-round"), t.size === "sm" || t.size === "small" ? o.push("button-small") : (t.size === "xl" || t.size === "large") && o.push("button-large"), t.iconOnly && o.push("button-has-icon-only"), t.block && o.push("button-block"), o;
      }),
      clickingHandle: i
    };
  }
});
function H(t, a, r, i, c, u) {
  const s = z("ArrowPathIcon");
  return h(), C("span", {
    class: g(t.containerClass)
  }, [
    k("button", $({ ref: "button" }, t.ionArgs), [
      k("span", {
        class: g(["button-inner", { "t-button-loading": t.clicking || t.clickingHandle }])
      }, [
        w(t.$slots, "default"),
        t.round ? _("", !0) : (h(), A(s, {
          key: 0,
          class: "t-button-loading-icon",
          "aria-hidden": "true"
        }))
      ], 2)
    ], 16)
  ], 2);
}
const N = /* @__PURE__ */ E(F, [["render", H]]);
export {
  N as default
};
//# sourceMappingURL=Button-CkAyItqk.js.map
